module.exports = __webpack_public_path__ + "img/small-8.f81f207d.jpg";